import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/settlementManage'
import BaseStore from '@store/table'

class Store extends BaseStore {
  @observable detail = {}
  @action
  getDetail = async () => {
    let { data, success } = await Api.getDetailApi()
    if (success) {
      runInAction(() => {
        this.detail = data || {}
        if (data && data.id) {
          this.$getList(1, { id: data.id })
        }
      })
    }
  }

  $listApi = Api.cashApi
  $getParams() {
    let { date, lead_name, lead_phone, order_no, ...rest } = this.$params
    const {
      detail: { id }
    } = this
    return {
      'created_at[from]': date && date[0] && date[0].format(__FMT1__),
      'created_at[to]': date && date[1] && date[1].format(__FMT1__),
      id,
      lead_name,
      lead_phone,
      order_no,
      ...rest
    }
  }

  @observable amount = 0
  @action
  getWallet = async () => {
    let {
      data: { amount }
    } = await Api.walletApi()
    runInAction(() => {
      this.amount = amount
    })
  }
}
export default new Store()
